import React from "react";
import AddIcon from "@material-ui/icons/Add";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { CBSearchField } from "../../../../../../features/forms/fields/cb-search-field/cb-search-field.component";
import { CheckboxField } from "../../../../../../features/forms/fields/checkbox-field/checkbox-field.component";
import { FileUploadWidget } from "../../../../../../features/file-attachments/file-upload-widget/file-upload-widget.component";
import { TemplateGridItem } from "../../../../../../components/template-grid/template-grid-item.component";

import { CbTemplateViewProps } from "../../../../types/cb-template-view/cb-template-view.props";
import { createCbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control-props.functions";

import { CbTemplateControlAdditionalDetails } from "../../../cb-template-control/components/cb-template-control-additional-details/cb-template-control-additional-details.component";
import { CbTemplateControlAnnouncementDate } from "../../../cb-template-control/components/cb-template-control-announcement-date/cb-template-control-announcement-date.component";
import { CbTemplateControlBackground } from "../../../cb-template-control/components/cb-template-control-background/cb-template-control-background.component";
import { CbTemplateControlContext } from "../../../cb-template-control/components/cb-template-control-context/cb-template-control-context.component";
import { CbTemplateControlExPlansDueAt } from "../../../cb-template-control/components/cb-template-control-ex-plans-due-at/cb-template-control-ex-plans-due-at.component";
import { CbTemplateControlHasVendorCommitment } from "../../../cb-template-control/components/cb-template-control-has-vendor-commitment/cb-template-control-has-vendor-commitment.component";
import { CbTemplateControlKeyFeatures } from "../../../cb-template-control/components/cb-template-control-key-features/cb-template-control-key-features.component";
import { CbTemplateControlLanguage } from "../../../cb-template-control/components/cb-template-control-language/cb-template-control-language.component";
import { CbTemplateControlLaunchDate } from "../../../cb-template-control/components/cb-template-control-launch-date/cb-template-control-launch-date.component";
import { CbTemplateControlLegalRequirements } from "../../../cb-template-control/components/cb-template-control-legal-requirements/cb-template-control-legal-requirements.component";
import { CbTemplateControlMarketingChannels } from "../../../cb-template-control/components/cb-template-control-marketing-channels/cb-template-control-marketing-channels.component";
import { CbTemplateControlMarketingSupportLevel } from "../../../cb-template-control/components/cb-template-control-marketing-support-level/cb-template-control-marketing-support-level.component";
import { CbTemplateControlNda } from "../../../cb-template-control/components/cb-template-control-nda/cb-template-control-nda.component";
import { CbTemplateControlNumberOfStores } from "../../../cb-template-control/components/cb-template-control-number-of-stores/cb-template-control-number-of-stores.component";
import { CbTemplateControlPreOrderDate } from "../../../cb-template-control/components/cb-template-control-pre-order-date/cb-template-control-pre-order-date.component";
import { CbTemplateControlProductPlacement } from "../../../cb-template-control/components/cb-template-control-product-placement/cb-template-control-product-placement.component";
import { CbTemplateControlRegions } from "../../../cb-template-control/components/cb-template-control-regions/cb-template-control-regions.component";
import { CbTemplateControlSalesForecast } from "../../../cb-template-control/components/cb-template-control-sales-forecast/cb-template-control-sales-forecast.component";
import { CbTemplateControlStartEndDate } from "../../../cb-template-control/components/cb-template-control-start-end-date/cb-template-control-start-end-date.component";
import { CbTemplateControlStatus } from "../../../cb-template-control/components/cb-template-control-status/cb-template-control-status.component";
import { CbTemplateControlTimeframe } from "../../../cb-template-control/components/cb-template-control-timeframe/cb-template-control-timeframe.component";
import { CbTemplateControlUnitForecast } from "../../../cb-template-control/components/cb-template-control-unit-forecast/cb-template-control-unit-forecast.component";
import { CbTemplateControlVendorAssetsReq } from "../../../cb-template-control/components/cb-template-control-vendor-assets-req/cb-template-control-vendor-assets-req.component";
import { CbTemplateControlWarehouseEta } from "../../../cb-template-control/components/cb-template-control-warehouse-eta/cb-template-control-warehouse-eta.component";
import { CbTemplateGrid } from "../../../cb-template-layout/components/cb-template-grid/cb-template-grid.component";
import { CbTemplateLayout } from "../../../cb-template-layout/components/cb-template-layout/cb-template-layout.component";
import { CbTemplateLayoutLeft } from "../../../cb-template-layout/components/cb-template-layout-left/cb-template-layout-left.component";
import { CbTemplateLayoutRight } from "../../../cb-template-layout/components/cb-template-layout-right/cb-template-layout-right.component";

export const CbTemplateNewProductLaunch = (props: CbTemplateViewProps) => {
  const controlProps = createCbTemplateControlProps(props);
  return (
    <CbTemplateLayout ndaData={props.ndaData}>
      <CbTemplateLayoutLeft>
        <CbTemplateControlBackground {...controlProps} />
        <CbTemplateControlStartEndDate {...controlProps} />

        <CbTemplateGrid>
          <TemplateGridItem>
            <CbTemplateControlMarketingSupportLevel {...controlProps} />
          </TemplateGridItem>
          <TemplateGridItem>
            <CbTemplateControlHasVendorCommitment {...controlProps} />
          </TemplateGridItem>
          <TemplateGridItem>
            <CbTemplateControlUnitForecast {...controlProps} />
          </TemplateGridItem>
          <TemplateGridItem>
            <CbTemplateControlSalesForecast {...controlProps} />
          </TemplateGridItem>
          <TemplateGridItem>
            <CbTemplateControlTimeframe {...controlProps} />
          </TemplateGridItem>
          <TemplateGridItem>
            <CbTemplateControlNumberOfStores {...controlProps} />
          </TemplateGridItem>
        </CbTemplateGrid>

        <CbTemplateControlContext {...controlProps} />
        <CbTemplateControlProductPlacement {...controlProps} />
        <CbTemplateControlKeyFeatures {...controlProps} />
        <CbTemplateControlAdditionalDetails {...controlProps} />
        <CbTemplateControlLegalRequirements {...controlProps} />
      </CbTemplateLayoutLeft>

      <CbTemplateLayoutRight>
        <CbTemplateControlStatus {...controlProps} />
        <CbTemplateControlNda {...props.ndaData} {...controlProps} />
        <CbTemplateControlExPlansDueAt {...controlProps} />
        <CbTemplateControlLaunchDate {...controlProps} />
        <CbTemplateControlLanguage {...controlProps} />
        <CbTemplateControlMarketingChannels {...controlProps} />
        <BorderedBlock>
          <CBSearchField
            form={props.form}
            label="Linked Campaign Briefs"
            name="linkedCampaignBriefs"
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <CbTemplateControlAnnouncementDate {...controlProps} />
        <CbTemplateControlPreOrderDate {...controlProps} />
        <CbTemplateControlWarehouseEta {...controlProps} />
        <CbTemplateControlVendorAssetsReq {...controlProps} />
        <BorderedBlock>
          <CbTemplateControlRegions bordersOff {...controlProps} />
          <CheckboxField label="MAP" name="isMap" {...controlProps} />
          <CheckboxField label="Is Exclusive" name="isExclusive" {...controlProps} />
          <CheckboxField label="In-store" name="isInstore" {...controlProps} />
          <CheckboxField label="Online" name="isOnline" {...controlProps} />
        </BorderedBlock>
        <FileUploadWidget
          onDeleteFile={props.onDeleteFile}
          onUploadFile={props.onUploadFile}
          overviewAttachments={props.attachedFiles}
          icon={<AddIcon />}
        >
          Add Files
        </FileUploadWidget>
      </CbTemplateLayoutRight>
    </CbTemplateLayout>
  );
};
